// Mask a phone number string, showing only the last 4 digits and replacing everything else with *
function maskPhoneNumber(phoneNumber: string): string {
  const visibleDigits = 4
  const maskedSectionLength = phoneNumber?.length - visibleDigits
  const maskedSection = '*'.repeat(
    maskedSectionLength > 0 ? maskedSectionLength : 0
  )
  const visibleSection = phoneNumber?.slice(-visibleDigits)
  return maskedSection + visibleSection
}

export default maskPhoneNumber
